<template>
  <div>
    <v-dialog v-model="dialogField" width="600px">
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orimary" text @click="dialogField = false">
            Fechar
          </v-btn>
        </v-card-actions>
        <v-card-title>
          <span class="headline">Selecionar ítem</span>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Descrição</th>
                  <th class="text-right">Adicionar</th>
                </tr>
              </thead>
              <tbody>
                <!-- <div > -->
                    <!-- <tr  v-if= "field.object =='quote'"> -->
                  <tr v-for="(field, indexField) in fields" :key="indexField" > 

                  <td>{{ field.description }}</td>

                  <td class="text-right">
                    <v-btn class="primary" @click="addField(indexField)"
                      >+</v-btn
                    >
                  </td>
                 
                </tr>
                <!-- </div> -->
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row class="ma-4">
      <v-col md="11" sm="12">
        <v-textarea :label ="label" v-model="formula.script" outlined rows="3">
        </v-textarea>

        <div
          class="text-body-1"
          :class="`blue-grey--text text--darken-2`"
          label="Campos"
        >
          Campos:
        </div>

        <v-row class="ma-1">
          <div class="text-center" label="Fields">
            <v-chip
              v-for="(field, indexField) in formula.fields"
              :key="indexField"
              class="ma-2"
              close
              @click:close="deleteField( indexField)"
              large
              style="height: 60px"
            >
              <span style="font-size:14px" >{{field.description}}</span>
              <!-- <v-text-field
                :disabled="field.default"
                :label="field.description"
                v-model.number="field.value"
              ></v-text-field> -->
            </v-chip>
            <v-btn
              class="secondary"
              @click="openDialogField()"
              style="border-radius: 25px"
              >+</v-btn
            >
          </div>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
        </v-row>
      </v-col>
      <v-col md="1" sm="12">
        <v-btn class="primary" @click="testFormula()">Teste</v-btn>
      </v-col>
    </v-row>
 
  </div>
</template>

<script>
export default {
  name: "edit-formula",
  props: ["formula", "fields", "object", "label"], // object: quote, product ...
  components: {},
  data() {
    return {
      dialogField: false,
      quote: {
        cost: 100,
        price: 100,
        fields: [
          // {"default":false,"object":"quote","id":"zwH8AtIaHusqdZjeMNDY","type":"","description":"Margem (%)",value:0}
        ],
      },

      solarPlant:{
        dcPower:100,
        nModules:100,
      },
      product:{
        cost:100,
        price:100,
      },
      site : {
        cityName : "Campinas - SP",
        city : {name:"Campinas - SP", stateName :"SP"}
      }
    };
  },
  methods: {
    testFormula() {
      var formula = this.formula;
      var fields = formula.fields;
      var script = formula.script;
      this.quote.fields = {};
      var site = {
        cityName : "Campinas - SP",
        city : {name:"Campinas - SP", stateName :"SP"}
      };
      var f = 0;
      //When the user creates a quote
      for (f = 0; f < fields.length; f++) {
        var field = fields[f];
        if (!field.default) {
          //this.quote.fields.push(field);
          this.quote.fields[field.id] = field;

        }
      }
      // var quote = this.quote;
      // var product = this.procuct;
      // var solarPlant= this.solarPlant;

      for (f = 0; f < fields.length; f++) {
        var field = fields[f];
        if (field.default) {
          script = script.replaceAll(`[${field.description}]`, field.id);
        } else {
          //var selField = this.quote.fields]
          // var selField = this.quote.fields.find(
          //   (element) => element.id == field.id
          // );
          // this.quote.fields.push(field);
          // script = script.replaceAll(
          //   `[${selField.description}]`,
          //   selField.id
          // );
           script = script.replaceAll(
            `[${field.description}]`,
             `quote.fields.${field.id}.value `
          );


        }
      }




      script = script.replaceAll("quote.", "this.quote.");
      script = script.replaceAll("product.", "this.product.");
      script = script.replaceAll("solarPlant.", "this.solarPlant.");
        script = script.replaceAll("site.", "this.site.");
     

      console.log(script);
     
      alert(script);
      try {
        eval(script);

        alert(
          `OK-  Custo: ${this.quote.price},   Preço: ${ this.quote.price
          }, Campos: ${JSON.stringify(this.quote.fields)} ,
          
          Custo produto: ${this.product.cost},   Preço: ${  this.product.price },

          Potência Dc: ${this.solarPlant.dcPower},  Número de módulos: ${ this.solarPlant.nModules},
          `
        );
      } catch (e) {
        alert(e);
        if (e instanceof SyntaxError) {
          alert(e);
        }
      }
    },
    openDialogField() {
      this.dialogField = true;
    },
    deleteField(indexField) {
      //alert(indexField);
      var field = this.formula.fields[indexField];
      this.formula.script = this.formula.script.replaceAll(
        `[${field.description}]`,
        ""
      );
      this.formula.fields.splice(indexField, 1);
      this.$forceUpdate();
    },
    addField(indexField) {
      this.formula.script += `[${this.fields[indexField].description}]`;
      var f = Object.assign({}, this.fields[indexField]);
      this.formula.fields.push(f);
      this.dialogField = false;
    },
  },
};
</script>
